import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { CookieBanner } from "./components/CookieBanner";
import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import { RecherchesPage } from "./pages/RecherchesPage";
import { VentesPage } from "./pages/VentesPage";
import { AutresServicesPage } from "./pages/AutresServicesPage";
import { HonorairesPage } from "./pages/HonorairesPage";
import { NosTrouvaillesPage } from "./pages/NosTrouvaillesPage";
import { FAQPage } from "./pages/FAQPage";
import { ContactPage } from "./pages/ContactPage";
import { MentionsLegalesPage } from "./pages/MentionsLegalesPage";
import "./App.css";

// Google Tag Manager setup
const GTM_ID = "GTM-KGXMH67T";

const initGTM = () => {
  // GTM Script
  const script = document.createElement("script");
  script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTM_ID}');
  `;
  document.head.appendChild(script);

  // GTM noscript iframe
  const noscript = document.createElement("noscript");
  const iframe = document.createElement("iframe");
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
  iframe.height = "0";
  iframe.width = "0";
  iframe.style.display = "none";
  iframe.style.visibility = "hidden";
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);
};

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Layout component
const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-grow">{children}</main>
      <Footer />
      <CookieBanner />
    </div>
  );
};

function App() {
  useEffect(() => {
    initGTM();
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/a-propos" element={<AboutPage />} />
          <Route path="/recherches" element={<RecherchesPage />} />
          <Route path="/ventes" element={<VentesPage />} />
          <Route path="/valorisation" element={<AutresServicesPage />} />
          <Route path="/honoraires" element={<HonorairesPage />} />
          <Route path="/nos-trouvailles" element={<NosTrouvaillesPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
